import React from 'react';
import User from '../../domain/User';
import Layout from '../../components/Layout';
import UserHeader from '../../components/header/User';
import Sponsor from '../../components/Sponsor';
import ChangePasswordContent from '../../components/content/ChangePassword';
import t from 'tcomb-form';
import { props } from 'tcomb-react';


@props({
  locale: t.Obj,
  doChangePassword: t.Func,
  user: User,
  message: t.maybe(t.ReactElement),
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func
})
export default class ChangePassword extends React.Component {

  getHeader() {
    return (
      <UserHeader user={this.props.user}
        locale={this.props.locale}
        goAccount={this.props.goAccount}
        goChangePassword={this.props.goChangePassword}
        goPurchases={this.props.goPurchases}
        doLogout={this.props.doLogout} />
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }
  render() {
    const { locale } = this.props;

    return (
      <Layout header={this.getHeader()} sponsor={this.getSponsor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <ChangePasswordContent
          locale={locale}
          doChangePassword={this.props.doChangePassword}
          user={this.props.user}
          message={this.props.message}
          goAccount={this.props.goAccount}
          goChangePassword={this.props.goChangePassword}
          goPurchases={this.props.goChangePassword}
          doLogout={this.props.doLogout}
          doAcceptCookies={this.props.doAcceptCookies} />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/ChangePassword.js
 **/